// extracted by css-extract-rspack-plugin
export default {"layout":"jwA8rGApBuEnrIq_","resizeHandle":"PgF_RHlGB7MKhXUA","toggle":"WlifI3vUvToH409V","tooltip":"wMPg9Wc4OrUZG3oz"};